import React from 'react';

import ResultImage from 'components/ui/Results/ResultImage';
import { ResultItemProps } from 'components/ui/Results/ResultItem';

function DefaultResultItem({ item, testId }: ResultItemProps) {
	const itemName = item.getDocumentValue('name');
	const url = item.getDocumentValue('url_detail');

	return (
		<div className="hawk-results__item">
			<ResultImage item={item} />

			<div className="hawk-results__item-name" data-testid={`hawk-result-${testId}`}>
				{url ? (
					<a className="hawk-results__item-name-link" href={url}>
						<span>{itemName}</span>
					</a>
				) : (
					<span>{itemName}</span>
				)}
			</div>
		</div>
	);
}

export default DefaultResultItem;
